export default __webpack_public_path__ + "static/media/download-dark.1a74552a.svg";